import type { LucideIcon } from 'lucide-react';
import { FolderOpen, Layers3, ShoppingCart, Siren } from 'lucide-react';

import { Card, CardContent } from '../ui/card';
import { Skeleton } from '../ui/skeleton';
import type { DashboardOverviewSummary } from '../../types/dashboard';

type DashboardKpiGridProps = {
  loading: boolean;
  summary: DashboardOverviewSummary;
};

type KpiCardDefinition = {
  key: keyof DashboardOverviewSummary;
  title: string;
  helper: string;
  icon: LucideIcon;
  iconClassName: string;
  iconWrapperClassName: string;
};

const KPI_CARDS: KpiCardDefinition[] = [
  {
    key: 'active_projects',
    title: 'Proyectos activos',
    helper: 'No finalizados',
    icon: FolderOpen,
    iconClassName: 'text-blue-600',
    iconWrapperClassName: 'bg-blue-100',
  },
  {
    key: 'in_progress_subprojects',
    title: 'Subproyectos en progreso',
    helper: 'Trabajo en curso',
    icon: Layers3,
    iconClassName: 'text-amber-600',
    iconWrapperClassName: 'bg-amber-100',
  },
  {
    key: 'open_orders',
    title: 'Pedidos abiertos',
    helper: 'Sin cancelar ni recibir',
    icon: ShoppingCart,
    iconClassName: 'text-emerald-600',
    iconWrapperClassName: 'bg-emerald-100',
  },
  {
    key: 'active_alerts',
    title: 'Alertas activas',
    helper: 'Pedidos y subproyectos',
    icon: Siren,
    iconClassName: 'text-rose-600',
    iconWrapperClassName: 'bg-rose-100',
  },
];

export function DashboardKpiGrid({ loading, summary }: DashboardKpiGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {KPI_CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <Card key={card.key} className="shadow-sm">
            <CardContent className="p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="space-y-1">
                  <p className="text-sm text-gray-600">{card.title}</p>
                  {loading ? (
                    <Skeleton className="h-8 w-20" />
                  ) : (
                    <p className="text-3xl font-semibold text-gray-900">
                      {summary[card.key]}
                    </p>
                  )}
                  <p className="text-xs text-gray-500">{card.helper}</p>
                </div>
                <div
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${card.iconWrapperClassName}`}
                >
                  <Icon className={`h-5 w-5 ${card.iconClassName}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
